// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__FemIz","col":"Create_col__45qBl"};